var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"main",class:{ 'meter-background': _vm.$route.name === 'MeterMenu' || _vm.$route.name === 'Meter' }},[_c('div',{staticClass:"content"},[(_vm.is_logged_user && _vm.projectExists)?_c('Notification'):_vm._e(),_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }